// extracted by mini-css-extract-plugin
export default {"none":"Loading_none__bEdC2","loading":"Loading_loading__wXYtV","uil_ring_css":"Loading_uil_ring_css__-E1Iy","uil-ring-anim":"Loading_uil-ring-anim__w82mB"};